<div
    class="mb-4 mt-3 overflow-hidden text-break"
    [class.mt-3]="isWidget"
    [class.truncate-incoming]="truncateReview"
    [style.backgroundColor]="bgcolor"
>
    <div class="position-relative d-flex text-start">
        <div class="me-3" style="min-width: 57px">
            <logo
                class="d-block rounded-circle overflow-hidden"
                [alt]="name"
                [logo]="photo"
                [size]="'57px'"
                [style.width]="'57px'"
            />
        </div>

        <div class="ms-1 flex-grow-1">
            <div class="d-flex justify-content-between">
                <div class="d-flex justify-content-between align-items-start w-100">
                    <div>
                        <div
                            *ngIf="displayNameMode == widgetNameDisplay.Long || !displayNameMode"
                            class="widget-subheading"
                        >
                            {{ (name ? name: '') + ' ' + (lastName ? lastName : '') }}
                        </div>

                        <div
                            *ngIf="displayNameMode == widgetNameDisplay.Short"
                            class="widget-subheading"
                        >
                            {{ (name ? name: '') + ' ' + (lastName ? lastName[0] + '.' : '')}}
                        </div>

                        <div
                            *ngIf="!isFeedback || isWidget"
                            class="d-flex align-items-center my-2"
                        >
                            <div style="font-size: 1.4rem">
                                <ngb-rating 
                                    [(rate)]="starPercentage"
                                    readonly="true"
                                    max="5">
                                    <ng-template let-fill="fill" let-index="index">
                                        <span *ngIf="fill === 100" class="star" [class.filled]="fill === 100" [style.color]="'#ffb200'">
                                            &#9733;
                                        </span>
                                    </ng-template>
                                </ngb-rating>
                            </div>

                            <div style="margin-left: 6px; color: #8E9299">
                                {{ created | date: 'shortDate' }}

                                <ng-container *ngIf="!isFeedback && !isWidget">from</ng-container>
                            </div>

                            <div *ngIf="!isFeedback && !isWidget && integrationFlow" style="margin-left: 6px">
                                <a
                                    style="text-decoration: none; color: #495057"
                                    [href]="reviewUrl"
                                    target="_blank"
                                >
                                    <img
                                        *ngIf="siteIcon && !isFeedback && !isWidget"
                                        class="review-site"
                                        [src]="siteIcon"
                                    />
                                </a>
                            </div>

                            <div *ngIf="!isFeedback && !isWidget && !integrationFlow" style="margin-left: 6px">
                                <img
                                    *ngIf="siteIcon && !isFeedback && !isWidget"
                                    class="review-site"
                                    [src]="siteIcon"
                                />

                                <ng-container *ngIf="!siteIcon">{{siteName}}</ng-container>
                            </div>

                            <i
                                *ngIf="!isFeedback && !isWidget && showShareIcon"
                                (click)="share.emit()"
                                class="fas share-icon fa-share-alt"
                            ></i>
                        </div>
                    </div>

                    <div>
                        <div class="location-name">{{ location }}</div>

                        <button
                            *ngIf="((replies?.length < numberOfAllowedReplies) && (!isFeedback || isWidget) && showReplyButton && permissions.addReviewSiteToLocation) ? true : false"
                            class="btn btn-outline-primary"
                            type="button"
                            (click)="showReplyEditor = true"
                        >
                            <icon-add-file style="margin-right: 2px" />
                            Reply
                        </button>

                        <button
                            class="btn btn-outline-danger ms-2"
                            type="button"
                            (click)="spamButtonClick()"
                        >
                            {{ isSpam ? 'Not spam' : 'Mark as Spam' }}
                        </button>
                    </div>
                </div>
            </div>
            
            <div
                class="widget-description mt-1 pe-2"
                [class.truncate]="truncateReview"
                [innerHtml]="reviewText"
            ></div>

            <div *ngIf="!isFeedback && !isWidget">
                <div 
                    (click)="showMore = !showMore" 
                    *ngIf="replies.length > 2" 
                    style="font-weight: 900; cursor: pointer;"
                >
                    {{ textReplies() }}
                </div>

                <ng-container *ngIf="showMore || replies.length <= 2">
                    <ng-container
                        *ngFor="let reply of replies"
                    >
                        <div *ngIf="!showReplyEditor" class="position-relative d-flex mt-3 text-start">
                            <div class="me-3" style="min-width: 48px">
                                <logo 
                                    class="d-block rounded-circle overflow-hidden"
                                    [alt]="reply.senderName"
                                    [logo]="showReplyEditor ? reply.photoUrl : null"
                                    [size]="'48px'"
                                    [style.width]="'48px'"
                                />
                            </div>

                            <div class="ms-1 flex-grow-1">
                                <div class="d-flex justify-content-between align-items-start mb-2">
                                    <div>
                                        <div class="widget-subheading">{{ reply.senderName }}</div>

                                        <div class="mt-1" style="color: #8E9299">
                                            {{ reply.dateResponse | date: 'shortDate' }}
                                        </div>
                                    </div>

                                    <div>
                                        <ng-container *ngIf="(showEditReplyButton && permissions.addReviewSiteToLocation) ? (siteName | someIntegrationEnabled) : false">
                                            <button
                                                class="btn btn-outline-primary"
                                                type="button"
                                                (click)="showReplyEditor = true"
                                            >
                                                <icon-edit style="margin-right: -2px" />
                                                Edit
                                            </button>

                                            <button
                                                *ngIf="!isFacebook(siteName)"
                                                class="btn btn-outline-danger ms-2"
                                                type="button"
                                                (click)="deleteReply.emit()"
                                            >
                                                <icon-delete style="margin-right: -3px" />
                                                Delete
                                            </button>
                                        </ng-container>
                                    </div>
                                </div>

                                <div class="widget-description pe-2" [innerHtml]="reply.messageResponse"></div>

                            </div>
                        </div>

                        <div *ngIf="showReplyEditor">
                            <reply-to-review
                                class="d-block mt-3"
                                [currentResponse] = "pendingReply ? pendingReply : reply.messageResponse"
                                (post) = "createPost($event); showReplyEditor = false;"
                                (cancel) = "showReplyEditor = false"
                                [reviewTargetName] = "siteName"
                                [isEnableOpenai] = "isEnableOpenaiIntegration"
                                [review] = "review"
                                [locationName] = "locationName"
                            />
                        </div>
                    </ng-container>

                    <ng-container *ngIf="showReplyEditor && !replies.length">
                        <reply-to-review
                            class="d-block mt-3"
                            [currentResponse] = "pendingReply"
                            (post) = "createPost($event); showReplyEditor = false;"
                            (cancel) = "showReplyEditor = false"
                            [isEnableOpenai] = "isEnableOpenaiIntegration"
                            [review] = "review"
                            [reviewTargetName] = "siteName"
                            [locationName] = "locationName"
                        />
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>

    <div *ngIf="isUnverified" class="unverified-content">
        <span class="unverified">Unverified Contact</span>
    </div>
</div>
